import React, { useEffect, useState } from "react";

import {
  Box,
  Typography,
  Button,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
} from "@mui/material";

import { DataGrid } from "@mui/x-data-grid";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import { getPendingOrders, confirmOrder } from "../../services/source";

const Armazem = () => {
  const [orders, setOrders] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [openProducts, setOpenProducts] = useState(false);
  const [message, setMessage] = useState("");

  const fetchOrders = async () => {
    try {
      const response = await getPendingOrders();

      setOrders(response.data.orders);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  const handleConfirm = async () => {
    try {
      const response = await confirmOrder({
        order_id: selectedOrder.id,
      });

      setMessage(response.data.message);

      setOpen(false);

      fetchOrders();
    } catch (error) {
      setMessage(error.response?.data?.message || "Erro ao confirmar pedido");

      console.error(error);
    }
  };

  const getCurrency = (location) => {
    return location?.trim().toLowerCase().includes("lisboa") ? "€" : "Kz";
  };

  const columns = [
    {
      field: "order_number",
      headerName: "Pedido",
      flex: 1.5,

      renderCell: (params) => (
        <Typography
          sx={{
            cursor: "pointer",
            color: "primary.main",
            fontWeight: "bold",
            "&:hover": {
              textDecoration: "underline",
            },
          }}
          onClick={() => {
            setSelectedOrder(params.row);
            setOpenProducts(true);
          }}
        >
          {params.value}
        </Typography>
      ),
    },

    {
      field: "customer_name",
      headerName: "Cliente",
      flex: 1,
    },

    {
      field: "total",
      headerName: "Total",
      width: 130,

      renderCell: (params) =>
        `${Number(params.value).toLocaleString()} ${getCurrency(params.row.items?.[0]?.location)}`,
    },

    {
      field: "status",
      headerName: "Estado",
      width: 130,

      renderCell: (params) => (
        <Chip
          label={params.value}
          color={params.value === "Pending" ? "warning" : "success"}
        />
      ),
    },

    {
      field: "created_at",
      headerName: "Data",
      flex: 1,
    },

    {
      field: "action",
      headerName: "Ação",
      width: 160,

      renderCell: (params) => (
        <Chip
          label="Confirmar"
          icon={<CheckCircleIcon />}
          color="success"
          onClick={() => {
            setSelectedOrder(params.row);
            setOpen(true);
          }}
        />
      ),
    },
  ];

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        px: {
          xs: 1,
          sm: 3,
          md: 5,
        },
        pb: 10,
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: 1400,
        }}
      >
        <Typography
          variant="h4"
          sx={{
            mb: 3,
            fontWeight: "bold",
            fontSize: {
              xs: "1.5rem",
              sm: "2rem",
            },
          }}
        >
          Saída Armazém
        </Typography>
        {message && (
          <Alert
            severity="warning"
            sx={{
              mb: 2,
            }}
            onClose={() => setMessage("")}
          >
            {message}
          </Alert>
        )}

        <Box
          sx={{
            width: "100%",
            backgroundColor: "white",
            borderRadius: 3,
            boxShadow: 3,
            overflow: "hidden",
          }}
        >
          <DataGrid
            rows={orders}
            columns={columns}
            autoHeight
            pageSizeOptions={[5, 10, 25]}
            disableRowSelectionOnClick
            sx={{
              border: 0,

              "& .MuiDataGrid-columnHeaders": {
                fontWeight: "bold",
              },

              "& .MuiDataGrid-cell": {
                display: "flex",
                alignItems: "center",
              },
            }}
          />
        </Box>

        <Dialog open={open} onClose={() => setOpen(false)}>
          <DialogTitle>Confirmar Pedido?</DialogTitle>

          <DialogContent>
            Deseja confirmar o pedido:
            <b> {selectedOrder?.order_number}</b>?
          </DialogContent>

          <DialogActions>
            <Button onClick={() => setOpen(false)}>Cancelar</Button>

            <Button variant="contained" color="success" onClick={handleConfirm}>
              Confirmar
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={openProducts}
          onClose={() => setOpenProducts(false)}
          fullWidth
          maxWidth="md"
        >
          <DialogTitle>
            Produtos do Pedido {selectedOrder?.order_number}
          </DialogTitle>

          <DialogContent>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: {
                  xs: "1fr",
                  sm: "repeat(2,1fr)",
                  md: "repeat(3,1fr)",
                },
                gap: 2,
                mt: 2,
              }}
            >
              {selectedOrder?.items?.map((item, index) => (
                <Box
                  key={index}
                  sx={{
                    borderRadius: 3,
                    boxShadow: 3,
                    p: 2,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Box
                    component="img"
                    src={`${process.env.REACT_APP_API_URL}/${item.image}`}
                    alt={item.title}
                    sx={{
                      width: 120,
                      height: 120,
                      objectFit: "cover",
                      borderRadius: 2,
                    }}
                  />

                  <Typography fontWeight="bold" textAlign="center" mt={1}>
                    {item.title}
                  </Typography>

                  <Typography>Código: {item.product_code}</Typography>

                  <Typography>Quantidade: {item.quantity}</Typography>

                  <Typography>
                    Preço: {Number(item.price).toLocaleString()}{" "}
                    {getCurrency(item.location)}
                  </Typography>

                  <Typography fontWeight="bold">
                    Total:{" "}
                    {(
                      Number(item.price) * Number(item.quantity)
                    ).toLocaleString()}{" "}
                    {getCurrency(item.location)}
                  </Typography>

                  {/* <Typography fontWeight="bold">
                    Total:{" "}
                    {(
                      Number(item.price) * Number(item.quantity)
                    ).toLocaleString()}{" "}
                    Kz
                  </Typography> */}
                </Box>
              ))}
            </Box>
          </DialogContent>

          <DialogActions>
            <Button onClick={() => setOpenProducts(false)}>Fechar</Button>
          </DialogActions>
        </Dialog>
      </Box>
    </Box>
  );
};

export default Armazem;
